const noop = require("mn-utils/noop");
const map = require("mn-utils/map");
const {INTERVALS} = require("../../../../constants/intervals");
const TimeIntervalBtn = require("../TimeIntervalBtn");
const SearchFilter = require("../SearchFilter");
const SelectFilter = require("../SelectFilter");
const React = require("react");

module.exports = (props) => {
  const {
    // default data from high level
    data = {},
    onChange = noop,
    search = {},
    selectFilters = [],
    hideTimeInterval,
    hideSearch,
    disabled,

    // components data from interval component
    TimeIntervalsComponent,
    searchComponent,
    selectComponent,
    additionalComponents
  } = props;

  return (
    <div className={'wAuto layoutRow fxwWrap ' + (props.className || '')}>
      {/*{!hideTimeInterval && timeIntervalBtnComponent && map(INTERVALS, (item) => (*/}
      {/*  <div key={item.id}>*/}
      {/*    <TimeIntervalBtn*/}
      {/*      item={item}*/}
      {/*      data={data}*/}
      {/*      btnComponent={timeIntervalBtnComponent}*/}
      {/*      onChange={onChange}*/}
      {/*      disabled={disabled}*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*))}*/}
      {!hideTimeInterval && TimeIntervalsComponent && (
        <TimeIntervalsComponent
          data={data}
          onChange={onChange}
          disabled={disabled}
        />
      )}
      {!hideSearch && (
        <div className="fx1">
          <SearchFilter
            data={data}
            search={search}
            searchComponent={searchComponent}
            onChange={onChange}
            disabled={disabled}
          />
        </div>
      )}
      {map(selectFilters, (selectParams, id) => (
        <div key={id}>
          <SelectFilter
            selectComponent={selectComponent}
            selectParams={selectParams}
            data={data}
            onChange={onChange}
            disabled={disabled}
          />
        </div>
      ))}
      {additionalComponents}
    </div>
  );
};
